export class PoBomItem {
    saleOrderId: number;
    itemCategoryId: number;
    itemSubCategoryId: number;
    itemId: number;
    sizeId:number;
    quantity: number;
    createdUser:string;
}